// This file was auto-generated by querybuilder/Apollo and should not be edited.

import * as ExtendedFormFieldErrors from './ExtendedFormFieldErrors';
import { TicketNumbersTicketNumberFormFormSetInput } from './globalTypes';
/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

import { WorkOrderTicketsInput } from "./globalTypes";

// ====================================================
// GraphQL mutation operation: WorkOrderTicketsMutation
// ====================================================

export interface WorkOrderTicketsMutation_output_errors_extendedMessages {
  /**
   * A human-readable validation error.
   */
  message: string;
  /**
   * A machine-readable representation of the error.
   */
  code: string | null;
}

export interface WorkOrderTicketsMutation_output_errors {
  /**
   * The camel-cased name of the input field, or '__all__' for non-field errors.
   */
  field: string;
  /**
   * A list of validation errors with extended metadata.
   */
  extendedMessages: WorkOrderTicketsMutation_output_errors_extendedMessages[];
}

export interface WorkOrderTicketsMutation_output_session {
  workOrderTickets: string[];
  hasSeenWorkOrderPage: boolean | null;
}

export interface WorkOrderTicketsMutation_output {
  /**
   * A list of validation errors in the form, if any. If the form was valid, this list will be empty.
   */
  errors: WorkOrderTicketsMutation_output_errors[];
  session: WorkOrderTicketsMutation_output_session | null;
}

export interface WorkOrderTicketsMutation {
  output: WorkOrderTicketsMutation_output;
}

export interface WorkOrderTicketsMutationVariables {
  input: WorkOrderTicketsInput;
}

export const BlankWorkOrderTicketsInput: WorkOrderTicketsInput = {
  "noTicket": false,
  "ticketNumbers": []
};


export const BlankTicketNumbersTicketNumberFormFormSetInput: TicketNumbersTicketNumberFormFormSetInput = {
  "ticketNumber": ""
};

export const WorkOrderTicketsMutation = {
  // The following query was taken from WorkOrderTicketsMutation.graphql.
  graphQL: `# This file was auto-generated by querybuilder, please do not edit it.
mutation WorkOrderTicketsMutation($input: WorkOrderTicketsInput!) {
  output: workOrderTickets(input: $input) {
    errors { ...ExtendedFormFieldErrors },
    session {
      workOrderTickets,
      hasSeenWorkOrderPage
    }
  }
}
${ExtendedFormFieldErrors.graphQL}`,
  name: "WorkOrderTicketsMutation",
  fetch(fetchGraphQL: (query: string, args?: any) => Promise<any>, args: WorkOrderTicketsMutationVariables): Promise<WorkOrderTicketsMutation> {
    return fetchGraphQL(WorkOrderTicketsMutation.graphQL, args);
  },
  blankInput: BlankWorkOrderTicketsInput,
};

export const fetchWorkOrderTicketsMutation = WorkOrderTicketsMutation.fetch;